import { Card, CardWithType, ICardType } from "../../../shared/types";
import { sanitizeImgUrls } from "../helpers/functions";
import { get, GetAllResponse, GetResponse, post, put, remove } from "./_base";

const path = "cards";

const sanitizeCard = (
  response: GetResponse<CardWithType>
): GetResponse<CardWithType> => {
  return {
    ...response,
    data: response?.data ? sanitizeCardData(response.data) : ({} as any),
  };
};

const sanitizeCardData = (card: CardWithType): CardWithType => {
  if (!card) return card;
  return {
    ...card,
    image: {
      ...card.image,
      path: sanitizeImgUrls(card.image?.path),
    },
    text: sanitizeImgUrls(card.text),
  };
};

const sanitizeCards = (
  response: GetAllResponse<CardWithType>
): GetAllResponse<CardWithType> => {
  return {
    ...response,
    data: Array.isArray(response?.data)
      ? response.data.map(sanitizeCardData)
      : [],
  };
};

export class CardActions {
  static post = async (data: CardWithType) => {
    return await post(path, data);
  };
  static get = async (data: ICardType & Partial<Card>) => {
    const response = (await get(path, data, {
      single: true,
    })) as GetResponse<CardWithType>;

    return sanitizeCard(response);
  };
  static getAll = async (data: ICardType & Partial<Card>) => {
    const response = (await get(path, data)) as GetAllResponse<CardWithType>;

    return sanitizeCards(response);
  };
  static put = async (data: ICardType & Card) => {
    return await put(path, data);
  };
  static remove = async (id: string) => {
    return await remove(path, id);
  };
}
